(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 769px)';
  var MOBILE_QUERY = '(max-width: 768.98px)';
  var SCROLL_EPSILON = 1;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function maxScroll(element) {
    return Math.max(0, element.scrollHeight - element.clientHeight);
  }

  function canScroll(element, delta) {
    if (!element) return false;

    var max = maxScroll(element);
    if (max <= SCROLL_EPSILON) return false;

    if (delta > 0) {
      return element.scrollTop < max - SCROLL_EPSILON;
    }

    return element.scrollTop > SCROLL_EPSILON;
  }

  function scrollColumn(element, delta) {
    var before = element.scrollTop;
    var max = maxScroll(element);

    element.scrollTop = clamp(before + delta, 0, max);

    return Math.abs(element.scrollTop - before) > 0.5;
  }

  function stickyHeaderBottom() {
    var header = document.querySelector('store-header[data-is-sticky="true"]');
    if (!header) return 0;

    var rect = header.getBoundingClientRect();
    return Math.max(0, rect.bottom);
  }

  function pageScrollBeforeLock(product, delta) {
    if (delta <= 0) return 0;

    var section = product.closest('.cc-main-product.product-main') || product;
    var lockTop = stickyHeaderBottom();
    var sectionTop = section.getBoundingClientRect().top;

    if (sectionTop <= lockTop + SCROLL_EPSILON) return 0;

    return Math.min(delta, sectionTop - lockTop);
  }

  function closestColumn(target, mediaColumn, infoColumn) {
    if (!target || !target.closest) return null;

    var column = target.closest('.product-media-column, .product-info');

    if (column === mediaColumn || column === infoColumn) {
      return column;
    }

    return null;
  }

  function columnFromPointer(event, product, mediaColumn, infoColumn) {
    var mediaRect = mediaColumn.getBoundingClientRect();
    var infoRect = infoColumn.getBoundingClientRect();

    if (event.clientX >= mediaRect.left && event.clientX <= mediaRect.right) {
      return mediaColumn;
    }

    if (event.clientX >= infoRect.left && event.clientX <= infoRect.right) {
      return infoColumn;
    }

    var productRect = product.getBoundingClientRect();
    var productMiddle = productRect.left + productRect.width / 2;

    return event.clientX < productMiddle ? mediaColumn : infoColumn;
  }

  function insertAfter(element, target) {
    if (!element || !target || !target.parentNode) return;
    target.parentNode.insertBefore(element, target.nextSibling);
  }

  function createPlaceholder(element, label) {
    if (!element || !element.parentNode) return null;

    var placeholder = document.createComment(label);
    element.parentNode.insertBefore(placeholder, element);
    return placeholder;
  }

  function restoreToPlaceholder(element, placeholder) {
    if (!element || !placeholder || !placeholder.parentNode) return;
    placeholder.parentNode.insertBefore(element, placeholder.nextSibling);
  }

  function initMobileMainProductOrder(product, infoColumn) {
    // Move the SSR image and the replaceable Rio mount together.
    var media = product.querySelector('pdp-gallery-shell') || product.querySelector('#product-media');
    var teaser = product.querySelector('.product-info__block--volume-discount-teaser');
    var recommendations = infoColumn.querySelector('.product-info__block--complementary');
    var serviceStrip = product.querySelector('.pdp-service-strip');
    var mediaPlaceholder = createPlaceholder(media, 'pdp original media position');
    var teaserPlaceholder = createPlaceholder(teaser, 'pdp original volume teaser position');
    var recommendationsPlaceholder = createPlaceholder(recommendations, 'pdp original recommendations position');
    var serviceStripPlaceholder = createPlaceholder(serviceStrip, 'pdp original service strip position');
    var mobileQuery = window.matchMedia(MOBILE_QUERY);

    function updateOrder() {
      if (mobileQuery.matches) {
        var mobileFeatures = infoColumn.querySelector('.product-info__block--features-mobile');
        var options = infoColumn.querySelector('.product-options');
        var mediaTarget = mobileFeatures || options;
        var buyButtons = infoColumn.querySelector('.product-info__block--buy-buttons');
        var tabs = product.querySelector('.product-media__tabs');
        var mediaBelow = product.querySelector('.product-media__below');

        // Keep the gallery above the mobile features and options as one stack.
        if (media && mediaTarget && mediaTarget.parentNode) {
          mediaTarget.parentNode.insertBefore(media, mediaTarget);
        }

        if (teaser && buyButtons) {
          insertAfter(teaser, buyButtons);
        }

        if (recommendations) {
          if (tabs) {
            insertAfter(recommendations, tabs);
          } else if (mediaBelow) {
            mediaBelow.appendChild(recommendations);
          }
        }

        if (serviceStrip) {
          if (recommendations) {
            insertAfter(serviceStrip, recommendations);
          } else if (tabs) {
            insertAfter(serviceStrip, tabs);
          }
        }
      } else {
        restoreToPlaceholder(media, mediaPlaceholder);
        restoreToPlaceholder(teaser, teaserPlaceholder);
        restoreToPlaceholder(recommendations, recommendationsPlaceholder);
        restoreToPlaceholder(serviceStrip, serviceStripPlaceholder);
      }
    }

    updateOrder();
    window.addEventListener('resize', updateOrder);
    window.addEventListener('load', updateOrder);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateOrder);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(updateOrder);
    }
  }

  function initProduct(product) {
    if (!product || product.dataset.pdpColumnScrollReady === 'true') return;

    var mediaColumn = product.querySelector('.product-media-column') || product.querySelector('.product-media');
    var infoColumn = product.querySelector('.product-info');
    var scrollSurface = product.closest('.cc-main-product.product-main') || product;

    if (!mediaColumn || !infoColumn) return;

    product.dataset.pdpColumnScrollReady = 'true';
    initMobileMainProductOrder(product, infoColumn);

    scrollSurface.addEventListener('wheel', function (event) {
      if (!window.matchMedia(DESKTOP_QUERY).matches) return;
      if (event.defaultPrevented || event.ctrlKey || event.metaKey) return;

      var delta = event.deltaY;
      if (!delta) return;

      var pageDelta = pageScrollBeforeLock(product, delta);

      if (pageDelta > SCROLL_EPSILON) {
        event.preventDefault();
        window.scrollBy(0, pageDelta);
        delta -= pageDelta;

        if (delta <= SCROLL_EPSILON) return;
      }

      var primary = closestColumn(event.target, mediaColumn, infoColumn) || columnFromPointer(event, product, mediaColumn, infoColumn);
      var secondary = primary === mediaColumn ? infoColumn : mediaColumn;

      if (canScroll(primary, delta)) {
        event.preventDefault();
        scrollColumn(primary, delta);
        return;
      }

      if (canScroll(secondary, delta)) {
        event.preventDefault();
        scrollColumn(secondary, delta);
        return;
      }

      if (delta > 0) {
        event.preventDefault();
        window.scrollBy(0, delta);
      }
    }, { passive: false, capture: true });
  }

  function init() {
    document.querySelectorAll('.cc-main-product.product-main .product').forEach(initProduct);
  }

  // This deferred script can place the gallery before later app scripts finish.
  // Waiting only for DOMContentLoaded needlessly holds up the final mobile layout.
  init();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
}());
